<script>
  /**
   * Horizontal grid lines, one per Y-axis tick.
   * Vertical grid is intentionally omitted — it would clash with the
   * quadrant median line.
   */
  let { yScale, innerW, ticks = 5 } = $props();

  const yTicks = $derived(yScale.ticks(ticks));
</script>

<g class="grid">
  {#each yTicks as t (t)}
    <line x1="0" x2={innerW} y1={yScale(t)} y2={yScale(t)} />
  {/each}
</g>
